export enum EnvironmentEnum {
    Netherlands = 'NL',
    Germany = 'DE',
    Spain = 'ES',
}
